import React from 'react';
import { confidencePoints } from '../data/content';
export function Confidence() {
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-22" data-mp="bdj2d8068wz8">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-23" data-mp="bby7tiduxe1d">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,4fr)_minmax(0,8fr)] lg:gap-16" data-id="element-24" data-mp="6dd6tgqs6qbv">
          <div data-id="element-25" data-mp="1fv4wab6lbdd">
            <p className="text-sm font-semibold text-sky-600" data-id="element-26" data-mp="1gd9bu7zyvwd">Why you can be confident</p>
            <p className="mt-4 font-display text-[5rem] font-extrabold leading-none tracking-tighter text-navy-800" data-id="element-27" data-mp="z1sfzmn8eefa">
              9<span className="text-sky-400" data-id="element-28" data-mp="u493osa3gbpz">/</span>10
            </p>
            <p className="mt-3 max-w-xs text-lg leading-relaxed text-navy-500" data-id="element-29" data-mp="pc8xii3fkmky">
              customers rehire us. When people trust you once, they trust you again — that
              isn&apos;t luck, it&apos;s consistency.
            </p>
          </div>

          <ul className="grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-30" data-mp="1hv64pa0cpomg">
            {confidencePoints.map(point => <li key={point.title} className="flex h-full gap-4" data-id="element-31" data-mp="1d0ien6pp8m5r">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md border border-navy-100 text-navy-600" data-id="element-32" data-mp="3hryrbdoueaw9">
                  <point.icon className="h-5 w-5" data-id="element-33" data-mp="3mrjslurhivc5" />
                </span>
                <div data-id="element-34" data-mp="380b3rnvepe02">
                  <h3 className="font-display text-[17px] font-bold leading-snug text-navy-800" data-id="element-35" data-mp="37z02pvtcikcn">
                    {point.title}
                  </h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-navy-400" data-id="element-36" data-mp="2yz371a8jgl83">{point.body}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}